import { fetcher } from '@commenda/utils';
import { TIndirectTaxCustomerDeleteResult } from './types';

export async function deleteIndirectTaxCustomer(
  customerId: string,
  corporationId: number
): Promise<TIndirectTaxCustomerDeleteResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/customers/${customerId}?corporation_id=${corporationId}`,
      {
        method: 'DELETE',
      },
      undefined
    );

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to delete customer',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: 'An unexpected error occurred while deleting the customer',
    };
  }
}
